import queryString from "query-string";
import React from "react";
import { useLocation } from "react-router-dom";

import Heading from "../../../../../shared/Heading_OLD/Heading";
import ImageCarousel from "../../../../../shared/ImageCarousel_OLD/ImageCarousel";
import InformationText from "../../../../../shared/InformationText_OLD/InformationText";
import BookActivity from "../BookActivity/BookActivity";
import GuideItemDesktopLogic from "./GuideItemDesktopLogic";

import { ALL_DAY_ACTIVITY, TV_TITLE, VERTICAL_ORDER } from "../../constants/constants";
import { durationLabel, expand_collapse } from "../shared/helpingFunctions";

import { formatTime, getCurrentDate } from "../../../../../helpingFunctions/dateTimeUtilities";
import { handleNullDisplay } from "../../../../../helpingFunctions/helpingFunctions";
import styles from "./GuideItemDesktop.module.scss";
import { useContext } from "react";
import { WhatsOnDataContext } from "../../../../../context/WhatsOnDataContext";

const GuideItemDesktop = ({
  selectedItemId,
  setSelectedItemId,
  itemIndex,
  guide,
  setView,
  guideItem,
  internalActivityItinerary,
  internalActivityItineraryHandler,
}) => {
  const { search } = useLocation();
  const { orientation, screenView } = queryString.parse(search);
  const isInTVVertical =
    screenView === TV_TITLE && orientation === VERTICAL_ORDER;

  const {
    Description,
    Location,
    Price,
    Title,
    Images,
    activityId,
    time,
    duration,
    StartTime,
    EndTime
  } = guideItem;
  const { selectedDate } = useContext(WhatsOnDataContext);

  const id = `${activityId}_${itemIndex}_${selectedDate}`;
  const isSelected = selectedItemId === id || selectedItemId === ALL_DAY_ACTIVITY;
  const isAllDayActivity = ALL_DAY_ACTIVITY === guideItem.Type;
  const { formattedDesc } = GuideItemDesktopLogic(
    Description,
    isSelected,
    guide
  );

  let SeeMoreElement = null;

  if (formattedDesc.hasMoreContent) {
    SeeMoreElement = (
      <span className={styles.GuideItemDesktop__seeMore}>
        {isSelected ? "See less" : "See more"}
      </span>
    );
  }

  let Img = null;
  if (isInTVVertical) {
    const img = Images.length > 0 ? Images[0] : null;
    if (img) {
      Img = (
        <img
          src={img.formats.small ? img.formats.small.url : img.url}
          alt="activity image"
          width={"100%"}
          height={"100%"}
        />
      );
    }
  } else {
    Img = (
      <ImageCarousel
        sliderImages={Images.length > 0 ? Images : []}
        view={"WhatsOnGuide_Card"}
      />
    );
  }

  return (
    <article
      className={`${styles.GuideItemDesktop} ${
        isSelected ? styles.GuideItemDesktop_Expand : ""
      } ${isInTVVertical ? styles.GuideItemDesktop__TV : ""}`}
      id={guideItem.timeId ? guideItem.timeId : "All Day Activities"}
    >
      <div className={styles.GuideItemDesktop__images_wrapper}>{Img}</div>
      <div
        className={styles.GuideItemDesktop__details}
        onClick={expand_collapse.bind(this, setSelectedItemId, id)}
      >
        <div className={styles.GuideItemDesktop__headline}>
          <Heading
            txt={Title}
            customHeadingClass={
              isInTVVertical
                ? styles.GuideItemDesktop__headingIsInTVVertical
                : styles.GuideItemDesktop__heading
            }
          />
          {!isAllDayActivity && (
            <BookActivity
              guideItem={guideItem}
              isInternalActivity={activityId?.includes("internalAct_facility")}
              setView={setView}
              internalActivityItinerary={internalActivityItinerary}
              internalActivityItineraryHandler={
                internalActivityItineraryHandler
              }
            />
          )}
        </div>
        <div className={styles.GuideItemDesktop__data}>
          <ul className={styles.GuideItemDesktop__cost}>
            <li>
              <strong>Price:</strong>{" "}
              {handleNullDisplay(Price, "£", "Inclusive")}
            </li>
            <li>
              <strong>{isAllDayActivity ? "End Time:" : "Duration:"}</strong>{" "}
              {isAllDayActivity
                ? formatTime(`${getCurrentDate()} ${EndTime}`)
                : durationLabel(duration)}
            </li>
          </ul>
          <ul className={styles.GuideItemDesktop__time_location}>
            <li>
              <strong>Start:</strong>{" "}
              {isAllDayActivity ? formatTime(`${getCurrentDate()} ${StartTime}`) : time}
            </li>
            <li>
              <strong>Location:</strong>{" "}
              {isAllDayActivity ? Location : Location?.locationName}
            </li>
          </ul>
        </div>

        <InformationText
          className={
            isInTVVertical
              ? styles.GuideItemDesktop__informationTextIsInTVVertical
              : styles.GuideItemDesktop__informationText
          }
          content={isInTVVertical ? Description : formattedDesc.desc}
        />
        {!isInTVVertical && SeeMoreElement}
      </div>
    </article>
  );
};

export default GuideItemDesktop;
